import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Typography } from "@mui/material";
import { useLocation, useParams } from "react-router";
const SuccessScreen = () => {
  const { language = "en" } = useParams()
  const { state } = useLocation()
  const closeTabMessage = language === "es"
    ? "¡Por favor cierre esta pestaña o abra otro formulario asignado!"
    : "Please close this tab";

  const successMessage = language === "es"
    ? "¡Sus respuestas han sido enviadas exitosamente!"
    : "Your responses have been successfully submitted!";

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center h-100"
      >
        <div className="text-center px-5">
          {
            state?.formSubmitted &&
            <CheckCircleRoundedIcon
              sx={{
                height: 110,
                width: 110,
                color: "limegreen",
              }}
            />

          }
          <div className="fs-5 pt-3">{state?.formSubmitted ? state?.message ? state?.message : successMessage : closeTabMessage}</div>
        </div>
      </div>
    </>
  );
};

export default SuccessScreen;